// extracted by mini-css-extract-plugin
module.exports = {"more-icon":"va_more-icon__1bhU-","option-div-transition":"va_option-div-transition__sRToO"};